/**
* Popup Configuration
*
* NOTE that additional popup configurations might be controlled by A/B Tests via Google Optimize!
*/
if(typeof FN == 'undefined') FN = {};

/**
* Halloween Mystery Sale: popups are shown only while the sale runs
* (the compressed replay window on staging, the real one in production)
*/
FN.mysterySaleActive = (function(){
  var now = Date.now();
  var staging = location.hostname === 'staging.git-tower.com';
  var starts = staging ? '2026-10-28T12:00:00Z' : '2026-10-29T12:00:00Z';
  var ends   = staging ? '2026-10-28T22:00:00Z' : '2026-10-31T12:00:00Z';
  return now >= Date.parse(starts) && now < Date.parse(ends);
})();

FN.popupConfig.addPopupConfig({
  'id': 'fn-popup-buy-git-ebook',
  'type': 'sidebar',
  'active': false,
  'pagePaths': ['git/ebook/en/command-line/.*'],
  'display': {
    'event': 'onLoad',
    'delay': 500
  },
  'content': [
    { 'type': 'link',
      'text': '<span class="fn-popup__text--line1">eBook Package</span><br /></span><span class="fn-popup__text--line2">Get this content in PDF, Kindle and iBook formats - all DRM-free!</span>',
      'action-button': 'Get the eBook',
      'url': FN.siteURL('learn', 'git/ebook#options') }
  ]
});
FN.popupConfig.addPopupConfig({
  'id': 'fn-popup-welcomemat_black-friday-sale',
  'type': 'welcome-mat',
  'active': FN.mysterySaleActive,
  'pagePaths': ['.*'],
  'display': {
    'event': 'onLoad',
    'delay': 2500,
    'cookieExpirationHours': 24
  },
  'content': [
    {
      'type': 'link',
      'text': '<a href="' + FN.siteURL('tower', 'pricing?utm_source=learn-website&amp;utm_medium=Popup&amp;utm_content=Welcome-Mat&amp;utm_campaign=Halloween-Mystery-Sale2026') + '"><picture><source type="image/avif" srcset="' + FN.config.urls.base + 'assets/img/popups/halloween-mystery-sale@2x.avif" /><img class="fn-popup__image--hero" src="' + FN.config.urls.base + 'assets/img/popups/halloween-mystery-sale@2x.png" width="911" height="514" alt="Halloween Mystery Sale: up to 50% off Tower, Oct 29–31" /></picture></a>',
    }
  ]
});
/* Slim bottom bar for phones, where the welcome mat is hidden */
FN.popupConfig.addPopupConfig({
  'id': 'fn-popup-mobilebanner_sale',
  'type': 'sidebar',
  'active': FN.mysterySaleActive,
  'pagePaths': ['.*'],
  'display': {
    'event': 'onLoad',
    'delay': 1500,
    'cookieExpirationHours': 24
  },
  'content': [
    {
      'type': 'link',
      'text': '<a class="fn-popup__banner-link" href="' + FN.siteURL('tower', 'pricing?utm_source=learn-website&amp;utm_medium=Popup&amp;utm_content=Mobile-Banner&amp;utm_campaign=Halloween-Mystery-Sale2026') + '"><span class="fn-popup__banner-text">🎃 <strong>Halloween Mystery Sale:</strong> up to 50% off · Oct&nbsp;29–31</span> <span class="fn-popup__banner-cta">See pricing →</span></a>',
    }
  ]
});
FN.popupConfig.addPopupConfig({
  'id': 'fn-popup-cheatsheets-twostep',
  'type': 'sidebar',
  'active': false,
  'pagePaths': ['.*'],
  'display': {
    'event': 'onLoad',
    'delay': 2000,
    'startSmall': true
  },
  'content': [
    { 'type': 'content',
      'text': '<img class="fn-popup__image--hero" src="' + FN.config.urls.base + 'assets/img/popups/cheat-sheet-git@2x.png" width="241" height="272" /><span class="fn-popup__text--line1">Git Cheat Sheet</span><br /><span class="fn-popup__text--line2">Get our popular <b>Cheat Sheet for Git</b> - for <b>free</b>!</span>',
      'action-button': 'Download for Free'
    },
    { 'type': 'newsletter-signup',
      'text': '<img class="fn-popup__image--hero" src="' + FN.config.urls.base + 'assets/img/popups/cheat-sheet-git@2x.png" width="241" height="272" /><span class="fn-popup__text--line1">Git Cheat Sheet</span><br /><span class="fn-popup__text--line2">We\'ll send you the Cheat Sheet straight to your inbox!</span>',
      'action-button': 'Download for Free',
      'signup-form': 7,
      'signup-medium': 'learn-website',
      'signup-URI': 'fn-popup-cheatsheets-signup',
      'tags': [
        { 'id': 'tower_newsletter', 'label': "Yes, send me the cheat sheet and sign me up for the Tower newsletter. It's free, it's sent infrequently, you can unsubscribe any time - and it's loved by over <b>100,000 developers & designers</b>!", 'default': false, 'hidden': false, 'required': true, 'collectConsent': true},
        { 'id': 'incentive_cheatpackage', 'label': "", 'default': true, 'hidden': true, 'collectConsent': false}
      ],
      'consent': [
        { 'id': 'legal', 'required': true, 'text': 'I have read and accept the <a href="' + FN.siteURL('tower', 'legal/privacy-policy') + '" target="_blank">Privacy Policy</a>. <br/>I understand that I can unsubscribe at any time.'}
      ]
    },
    { 'type': 'tweet',
      'text': '<span class="fn-popup__text--line1">The Cheat Sheet is on its Way to Your Inbox!</span><br /><span class="fn-popup__text--line2">While you\'re waiting: Tweet for a chance to win one of our awesome T-Shirts.</span><span class="fn-popup__image"><img src="' + FN.config.urls.base + 'assets/img/popups/tower-shirts-collage@2x.png" width="153" /></span>',
      'action-button': 'Tweet Now',
      'tweet': {'platform': 'twitter', 'url':  'http://www.git-tower.com/learn/', 'text': 'Learn version control with Git for free - with awesome online books, videos & tutorials. #learngit '}
    }
  ]
});
FN.popupConfig.addPopupConfig({
  'id': 'fn-popup-poster-giveaway',
  'type': 'sidebar',
  'active': false,
  'pagePaths': ['.*'],
  'display': {
    'event': 'onLoad',
    'delay': 2000,
    'startSmall': true
  },
  'content': [
    { 'type': 'content',
      'text': '<img class="fn-popup__image--hero" src="' + FN.config.urls.base + 'assets/img/popups/poster-dev-manifesto@2x.png" width="222" height="284" /><span class="fn-popup__text--line1"><h6>The Dev Manifesto</h6></span><br /><span class="fn-popup__text--line2">Win one of our popular, museum-quality posters!</span>',
      'action-button': 'Enter to Win'
    },
    { 'type': 'newsletter-signup',
      'text': '<img class="fn-popup__image--hero" src="' + FN.config.urls.base + 'assets/img/popups/poster-dev-manifesto@2x.png" width="222" height="284" /><span class="fn-popup__text--line1">Subscribe to our newsletter for a chance to win!</span>',
      'action-button': 'Subscribe',
      'signup-form': 7,
      'signup-medium': 'learn-website',
      'signup-URI': 'fn-popup-poster-giveaway',
      'tags': [
        { 'id': 'tower_newsletter', 'label': "Yes, sign me up for the Tower newsletter. It's free, it's sent infrequently, you can unsubscribe any time - and it's loved by over <b>100,000 developers & designers</b>!", 'default': false, 'hidden': false, 'required': true, 'collectConsent': true},
        { 'id': 'incentive_postergiveaway', 'label': "", 'default': true, 'hidden': true, 'collectConsent': false}
      ],
      'consent': [
        { 'id': 'legal', 'required': true, 'text': 'I have read and accept the <a href="' + FN.siteURL('tower', 'legal/privacy-policy') + '" target="_blank">Privacy Policy</a>. <br/>I understand that I can unsubscribe at any time.'}
      ]
    },
    { 'type': 'tweet',
      'text': '<span class="fn-popup__text--line1"><h6>Thanks for taking part - and good luck!</h6></span><br /><span class="fn-popup__text--line2">Please check your inbox to confirm subscription.</span>',
      'action-button': 'Share on Twitter',
      'footer': 'We\'ll pick 4 winners every month who share this tweet!<br>Follow <a href="https://x.com/gittower" target="_blank">@gittower</a> to be notified if you win!',
      'tweet': {'platform': 'twitter', 'url':  'http://www.git-tower.com/learn/', 'text': 'Learn version control with Git for free - with awesome online books, videos & tutorials. #learngit '}
    }
  ]
});


/*****
* onClick Popups
*/
FN.popupConfig.addPopupConfig({
  'id': 'fn-signup-popup_incentive_cheatpackage',
  'type': 'modal',
  'active': true,
  'pagePaths': ['.*'],
  'display': {
    'event': 'onClick',
    'selector': '.button--incentive_cheatpackage',
    'showOnlyOnce': false
  },
  'content': [
    { 'type': 'newsletter-signup',
      'text': '<h2 class="fn-popup__text--headline">Download the Cheat Sheet<span class="fn-popup__text--tag">Free</span></h2><p class="fn-popup__text--subline">Get 18 of our most popular Cheat Sheets in one handy ZIP!</p><span class="fn-popup__image"><img src="' + FN.config.urls.base + 'assets/img/popups/cheat-sheet-git@2x.png" /></span>',
      'action-button': 'Get the Package',
      'signup-form': 7,
      'signup-medium': 'learn-website',
      'signup-URI': 'fn-signup-popup_incentive_cheatpackage',
      'tags': [
        { 'id': 'tower_newsletter', 'label': "Yes, send me the package and sign me up for the Tower newsletter. It's free, it's sent infrequently, you can unsubscribe any time - and it's loved by over <b>100,000 developers & designers</b>!", 'default': false, 'hidden': false, 'required': true, 'collectConsent': true},
        { 'id': 'incentive_cheatpackage', 'label': "", 'default': true, 'hidden': true, 'collectConsent': false}
      ],
      'consent': [
        { 'id': 'legal', 'required': true, 'text': 'I have read and accept the <a href="' + FN.siteURL('tower', 'legal/privacy-policy') + '" target="_blank">Privacy Policy</a>. <br/>I understand that I can unsubscribe at any time.'}
      ]
    },
    { 'type': 'tweet',
      'text': '<h2 class="fn-popup__text--headline">Thanks! Please Check Your Inbox!</h2><p class="fn-popup__text--subline">Want to win one of our awesome Tower shirts?<br><b>Tell your friends about the package!</b></p><span class="fn-popup__image"><img src="' + FN.config.urls.base + 'assets/img/popups/tower-shirts@2x.png" width="360" /></span>',
      'action-button': 'Share on Twitter',
      'footer': 'We\'ll pick 4 winners every month who share this tweet!<br>Follow <a href="https://x.com/gittower" target="_blank">@gittower</a> to be notified if you win!',
      'tweet': {'platform': 'twitter', 'url':  'http://www.git-tower.com/learn/', 'text': "Learn version control with Git for free - with awesome online books, videos & tutorials. #learngit "}
    }
  ]
});



/***
* Merchandise Store Gift Coupon
*/
FN.popupConfig.addPopupConfig({
  'id': 'fn-popup-merchandise-gift-coupon',
  'type': 'modal',
  'active': false,
  'pagePaths': ['.*'],
  'display': {
    'event': 'onLoad',
    'delay': 2000
  },
  'content': [
    { 'type': 'newsletter-signup',
      'text': '<h2 class="fn-popup__text--headline">$100 Gift Coupon</h2><p class="fn-popup__text--subline">Sign up for our <em>free</em> newsletter and <b>win a $100 voucher</b> for our <b><a href="https://stuff.git-tower.com" target="_blank">T-shirt and poster shop</a></b>. We pick a winner every month. All new subscribers are eligible.</p><span class="fn-popup__image"><img src="' + FN.config.urls.base + 'assets/img/popups/giftbox.gif" /></span>',
      'action-button': 'Sign Up to Win',
      'signup-form': 7,
      'signup-medium': 'learn-website',
      'signup-URI': 'fn-signup-popup_incentive_merchandise-gift-coupon',
      'tags': [
        { 'id': 'tower_newsletter', 'label': "", 'default': true, 'hidden': true, 'required': true, 'collectConsent': false},
        { 'id': 'incentive_merchandise-gift-coupon', 'label': "", 'default': true, 'hidden': true, 'required': true, 'collectConsent': false}
      ],
      'consent': [
        { 'id': 'legal', 'required': true, 'text': 'I have read and accept the <a href="' + FN.siteURL('tower', 'legal/privacy-policy') + '" target="_blank">Privacy Policy</a>. <br/>I understand that I can unsubscribe at any time.'}
      ]
    },
    { 'type': 'tweet',
      'text': '<h2 class="fn-popup__text--headline">Thanks & Good Luck</h2><span class="fn-popup__text--subline">Thanks for signing up! Please check your inbox to confirm your subscription.<br><br>Best of luck for the giveaway!</span><span class="fn-popup__image"><img src="' + FN.config.urls.base + 'assets/img/tower-icon.svg" /></span>',
      'action-button': 'Tweet About This',
      'footer': 'We\'ll pick 4 winners every month who share this tweet!<br>Follow <a href="https://x.com/gittower" target="_blank">@gittower</a> to be notified if you win!',
      'tweet': {'platform': 'twitter', 'url':  'http://www.git-tower.com/learn/', 'text': "Learn version control with Git for free - with awesome online books, videos & tutorials. #learngit "}
    }
  ]
});
FN.popupConfig.addPopupConfig({
  'id': 'fn-popup-merchandise-gift-coupon_inline',
  'type': 'inline',
  'active': false,
  'pagePaths': ['.*'],
  'display': {
    'event': 'onScroll',
    'beforeElement': '#fn-popup-merchandise-gift-coupon_inline ~',
    'withDistance': '-200',
  },
  'content': [
    { 'type': 'newsletter-signup',
      'text': '<h2 class="fn-popup__text--headline">$100 Gift Coupon</h2><p class="fn-popup__text--subline">Sign up for our <em>free</em> newsletter and <b>win a $100 voucher</b> for our <b><a href="https://stuff.git-tower.com" target="_blank">T-shirt and poster shop</a></b>. We pick a winner every month. All new subscribers are eligible.</p><span class="fn-popup__image"><img src="' + FN.config.urls.base + 'assets/img/popups/giftbox.gif" /></span>',
      'action-button': 'Sign Up to Win',
      'signup-form': 7,
      'signup-medium': 'learn-website',
      'signup-URI': 'fn-signup-popup_incentive_merchandise-gift-coupon',
      'tags': [
        { 'id': 'tower_newsletter', 'label': "", 'default': true, 'hidden': true, 'required': true, 'collectConsent': false},
        { 'id': 'incentive_merchandise-gift-coupon', 'label': "", 'default': true, 'hidden': true, 'required': true, 'collectConsent': false}
      ],
      'consent': [
        { 'id': 'legal', 'required': true, 'text': 'I have read and accept the <a href="' + FN.siteURL('tower', 'legal/privacy-policy') + '" target="_blank">Privacy Policy</a>. <br/>I understand that I can unsubscribe at any time.'}
      ]
    },
    { 'type': 'tweet',
      'text': '<h2 class="fn-popup__text--headline">Thanks & Good Luck</h2><span class="fn-popup__text--subline">Thanks for signing up! Please check your inbox to confirm your subscription.<br><br>Best of luck for the giveaway!</span><span class="fn-popup__image"><img src="' + FN.config.urls.base + 'assets/img/tower-icon.svg" /></span>',
      'action-button': 'Tweet About This',
      'footer': 'We\'ll pick 4 winners every month who share this tweet!<br>Follow <a href="https://x.com/gittower" target="_blank">@gittower</a> to be notified if you win!',
      'tweet': {'platform': 'twitter', 'url':  'http://www.git-tower.com/learn/', 'text': "Learn version control with Git for free - with awesome online books, videos & tutorials. #learngit "}
    }
  ]
});


/****
* Welcome Mat
*/
FN.popupConfig.addPopupConfig({
  'id': 'fn-popup-git-cheat-sheet-welcomemat',
  'type': 'welcome-mat',
  'active': false,
  'pagePaths': ['git/commands/.*'],
  'display': {
    'event': 'onLoad',
    'delay': 1000
  },
  'content': [
    { 'type': 'newsletter-signup',
      'text': '<h2 class="fn-popup__text--headline">Get our popular <b>Git Cheat Sheet</b> for free!</h2><p class="fn-popup__text--subline">You\'ll find the most important commands on the front and helpful best practice tips on the back. Over <b>100,000 developers</b> have downloaded it to make Git a little bit easier.</p>',
      'action-button': 'Download for Free',
      'signup-form': 7,
      'close-button': 'No, Thanks',
      'source-product': 'learn-website',
      'source-URI': 'fn-popup-cheatsheets-signup',
      'tags': [
          { 'id': 'tower_newsletter', 'label': "Yes, send me the cheat sheet and sign me up for the Tower newsletter. It's free, it's sent infrequently, you can unsubscribe any time.", 'default': false, 'hidden': false, 'collectConsent': true},
          { 'id': 'incentive_cheatpackage', 'label': "", 'default': true, 'hidden': true, 'collectConsent': false}
      ],
      'consent': [
          { 'id': 'legal', 'required': true, 'text': 'I have read and accept the <a href="' + FN.siteURL('tower', 'legal/privacy-policy') + '" target="_blank">Privacy Policy</a>.'}
      ]
    },
    { 'type': 'tweet',
      'text': '<h3 class="fn-popup__text--headline">The Cheat Sheet is on its Way to Your Inbox!</h3><p class="fn-popup__text--subline">While you\'re waiting: Tweet for a chance to win one of our awesome T-Shirts.</p><br><span class="fn-popup__image"><img src="' + FN.config.urls.base + 'assets/img/popups/tower-shirts-collage@2x.png" width="153" /></span>',
      'action-button': 'Tweet Now',
      'tweet': {'platform': 'twitter', 'url':  'http://www.git-tower.com/learn/', 'text': 'Learn version control with Git for free - with awesome online books, videos & tutorials. #learngit '}
    }
  ]
});

FN.popupConfig.addPopupConfig({
  'id': 'fn-popup-welcomemat-git-webinar-20201027',
  'type': 'welcome-mat',
  'active': false,
  'pagePaths': ['git/faq/.*', 'git/commands/.*'],
  'display': {
    'event': 'onLoad',
    'delay': 1000
  },
  'content': [
    { 'type': 'link',
      'text': '<h2 class="fn-popup__text--headline">17 Ways to <b>Undo Mistakes</b> in Git!</h2><p class="fn-popup__text--subline">Get a spot on our popular, 1-hour <b>live webinar</b> and learn how to roll back, revert, and generally undo almost any mistakes in Git.<br><br>The webinar is <b>free</b>, but <b>seats are limited</b>!</p>',
      'action-button': 'Learn More',
      'url': FN.siteURL('learn', 'git/webinar/undoing-things-with-git') }
  ]
});

FN.popupConfig.addPopupConfig({
  'id': 'fn-popup-welcomemat-git-webinar-20191120',
  'type': 'welcome-mat',
  'active': false,
  'pagePaths': ['git/faq/.*', 'git/commands/.*'],
  'display': {
    'event': 'onLoad',
    'delay': 1000
  },
  'content': [
    { 'type': 'link',
      'text': '<h2 class="fn-popup__text--headline">17 Ways to <b>Undo Mistakes</b> in Git with Tower!</h2><p class="fn-popup__text--subline">Get a spot on our popular, 1-hour <b>live webinar</b> and learn how to roll back, revert, and generally undo almost any mistakes in Git. We\'ll be using <a href="' + FN.siteURL('tower') + '" target="_blank">Tower</a>, the popular Git desktop client, to make undoing things in Git easy as pie!<br><br>The webinar is <b>free</b>, but <b>seats are limited</b>!</p>',
      'action-button': 'Learn More',
      'url': FN.siteURL('learn', 'git/webinar/undoing-things-with-tower') }
  ]
});

FN.popupConfig.addPopupConfig({
  'id': 'fn-popup-welcomemat-git-webinar-20191106',
  'type': 'welcome-mat',
  'active': false,
  'pagePaths': ['git/faq/.*', 'git/commands/.*'],
  'display': {
    'event': 'onLoad',
    'delay': 1000
  },
  'content': [
    { 'type': 'link',
      'text': '<h2 class="fn-popup__text--headline">More Productive in Git with Tower</h2><p class="fn-popup__text--subline">Get a spot on our popular, 1-hour <b><a href="' + FN.siteURL('learn', 'git/webinar/more-productive-in-git-with-tower') + '" target="_blank">live webinar</a></b> and learn how to become <b>more productive in Git</b>. We\'ll be using <a href="' + FN.siteURL('tower') + '" target="_blank">Tower</a>, the popular Git desktop client, to make many complex workflows as easy as drag and drop!<br><br>The webinar is <b>free</b>, but <b>seats are limited</b>!</p>',
      'action-button': 'Learn More',
      'url': FN.siteURL('learn', 'git/webinar/more-productive-in-git-with-tower') }
  ]
});
